import { useEffect } from "react";
import { IoCallOutline } from "react-icons/io5";
import { AiOutlinePrinter } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { Link } from "react-router-dom";
import './footer.css';

const imageUrl = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_5.png";

/** Small helper: inject a script once by ID */
function injectScriptOnce({ id, src, async = true }) {
  if (typeof document === "undefined") return;
  if (document.getElementById(id)) return; // already added
  const s = document.createElement("script");
  s.id = id;
  s.src = src;
  s.async = async;
  document.body.appendChild(s);
}


const Footer = () => {

  // useEffect(() => {
  //   if (document.readyState === "complete") {
  //     loadJotform();
  //   } else {
  //     window.addEventListener("load", loadJotform);
  //     return () => window.removeEventListener("load", loadJotform);
  //   }

  //   function loadJotform() {
  //     const script = document.createElement("script");
  //     script.src = "https://cdn.jotfor.ms/agent/embedjs/019897a74aa7753b94a0bc5025324089f7d6/embed.js?skipWelcome=1&maximizable=1";
  //     script.async = true;
  //     document.body.appendChild(script);
  //   }
  // }, []);


  // useEffect(() => {
  //   const onLoad = () => {
  //     // --- Jotform AI (right) ---
  //     // Adjust query params as needed: skipWelcome=1 prevents auto-popup, maximizable=1 shows expand icon
  //     injectScriptOnce({
  //       id: "jotform-ai-embed",
  //       src: "https://cdn.jotfor.ms/agent/embedjs/019897a74aa7753b94a0bc5025324089f7d6/embed.js?skipWelcome=1&maximizable=1",
  //     });


  //     // --- Tidio AI (left) ---
  //     // Use the exact property key you provided
  //     injectScriptOnce({
  //       id: "tidio-chat-embed",
  //       src: "//code.tidio.co/bpqjjbbrbfapwhsycbie0acp5zbktr4c.js",
  //     });
  //   };


  //   if (document.readyState === "complete") onLoad();
  //   else window.addEventListener("load", onLoad);


  //   return () => window.removeEventListener("load", onLoad);
  // }, []);


  const FooterBgImg = {
    backgroundImage: `url(${imageUrl})`,
    height: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    overflow: "hidden",
  };

  const Line = {
    display: "block",
    height: "2px",
    width: "80px",
    margin: "10px 0 0 0",
    background: "#9E1B1E",
  };

  return (
    <>
      <footer className="footer-area" style={FooterBgImg} >
        {/*Start Footer Top*/}
        <div className="footer-top">

          <div className="container">
            <div className="row">
              {/*Start single footer widget*/}
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 single-widget">
                <div className="single-footer-widget single-footer-widget--link-box">
                  <div className="title">
                    <h5 className="text-white">INDO ZAMBIA BANK</h5>
                  </div>
                  <span style={Line}></span>
                  <div className="footer-widget-links">
                    <p className="text-white footer-description">
                      Indo Zambia Bank was formed on 19th October, 1984 by the
                      Government of the Republic of Zambia and the Government of
                      India out of the desire to promote banking facilities to
                      support the economic development of Zambia
                    </p>
                  </div>
                  <div className="social mt-5">
                    <h6 className="text-white">Follow US</h6>
                    <div className="footer-social-link pt-4">
                      <ul className="clearfix">
                        <li>
                          <a href="https://www.linkedin.com/company/indo-zambia-bank/">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/indo_zambia_bank/">
                            <i className="fab fa-instagram" />
                          </a>
                        </li>
                        <li>
                          <a href="https://mobile.twitter.com/IndoZambiaBank">
                            <i class="fa-brands fa-x-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.facebook.com/IndoZambiaBank?_rdc=1&_rdr#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*End single footer widget*/}

              {/*Start single footer widget*/}
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 single-widget">
                <div className="single-footer-widget single-footer-widget--link-box">
                  <div className="title">
                    <h3>Support</h3>
                  </div>
                  <span style={Line}></span>
                  <div className="footer-widget-links footer-support d-flex align-items-center">
                    <IoCallOutline color="#b8b4b1" size={25} className="me-3" />
                    <p className="text-white">
                      +260 211 224 653/225 080,<br /> +211 227194, +211 22079
                    </p>

                  </div>
                </div>
                <div className="footer-widget-links footer-support d-flex align-items-center">
                  <AiOutlinePrinter size={25} color="#FFF" className="me-3" />
                  <p className="text-white">
                    +260 211 225 090
                  </p>

                </div>
                <div className="footer-widget-links footer-support d-flex align-items-center">
                  <AiOutlineMail color="#FFF" size={25} className="me-3" />
                  <p className="text-white">
                    izb@izb.co.zm<br />customerservice@izb.co.zm
                  </p>

                </div>
              </div>
              {/*End single footer widget*/}

              {/*Start single footer widget*/}
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 single-widget">
                <div className="single-footer-widget single-footer-widget--link-box">
                  <div className="title">
                    <h3>Useful Links</h3>
                  </div>
                  <span style={Line}></span>

                  <div className="footer-widget-links">
                    <ul>
                      <li>
                        <a href="/Feedback-Complaint">Feedback / Complaint</a>
                      </li>
                      <li>
                        <a href="/Career">Vacancies</a>
                      </li>
                      <li>
                        <Link to="/FAQS">FAQs</Link>
                      </li>
                      <li>
                        <a href="#">Download</a>
                      </li>
                      <li>
                        <a href="#">Branch Codes</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/*End single footer widget*/}

              {/*Start single footer widget*/}
              <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 single-widget">
                <div className="single-footer-widget single-footer-widget--link-box">
                  <div className="title">
                    <h3>Other Links</h3>
                  </div>
                  <span style={Line}></span>
                  <div className="footer-widget-links">
                    <ul>
                      <li>
                        <Link to="/DigitalBankingPrivacyPolicy" className="text-left" style={{ textAlign: "left" }}>Digital Banking Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/Disclaimer">Disclaimer</Link>
                      </li>
                      <li>
                        <Link to="/PrivacyPolicy">Privacy Policy</Link>
                      </li>
                      <li>
                        <a href="#">Notice</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/*End single footer widget*/}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="bottom-inner">
              <p className="text-white">© {new Date().getFullYear()} Indo Zambia Bank. All rights reserved..</p>
              <p className="text-white">Indo Zambia Bank, A Registered Commercial Bank.</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
